import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import classNames from "classnames";
import { Typography } from "./Typography";
import * as IconComponents from "./icons";
import { FOCUS_VISIBLE_OUTLINE } from "../utils/css-helpers";
import { ThemeProviderContext } from "./ThemeProvider";
export const colors = [
    "neutral",
    "critical",
    "attention",
    "success",
    "informational",
    "branded",
];
export const DeletableTag = ({ color = "neutral", className = "", text, iconName, avatar, onDelete, testId, isDisabled, }) => {
    const theme = useContext(ThemeProviderContext);
    const colorClassName = {
        neutral: [
            "bg-general-neutral-tertiary",
            "dark:bg-general-neutral-tertiary-darkmode",
        ],
        critical: [
            "bg-general-red-tertiary",
            "dark:bg-general-red-tertiary-darkmode",
        ],
        attention: [
            "bg-general-yellow-tertiary",
            "dark:bg-general-yellow-tertiary-darkmode",
        ],
        success: [
            "bg-general-green-tertiary",
            "dark:bg-general-green-tertiary-darkmode",
        ],
        informational: [
            "bg-general-blue-tertiary",
            "dark:bg-general-blue-tertiary-darkmode",
        ],
        branded: [
            "bg-general-indigo-tertiary",
            "dark:bg-general-indigo-tertiary-darkmode",
        ],
    };
    const deletableTagClassName = classNames("rounded-full", "text-center", "max-w-fit", "inline-flex", "whitespace-nowrap", "place-content-center", "items-center", "pl-1", FOCUS_VISIBLE_OUTLINE, colorClassName[color], className);
    const deletableAreaHoverClassName = {
        neutral: [
            "hover:bg-accent-neutral-secondary",
            "dark:hover:bg-accent-neutral-secondary-darkmode",
        ],
        critical: [
            "hover:bg-general-red-primary-secondary",
            "dark:hover:bg-general-red-primary-secondary-darkmode",
        ],
        attention: [
            "hover:bg-general-yellow-secondary",
            "dark:hover:bg-general-yellow-secondary-darkmode",
        ],
        success: [
            "hover:bg-general-green-secondary",
            "dark:hover:bg-general-green-secondary-darkmode",
        ],
        informational: [
            "hover:bg-general-blue-secondary",
            "dark:hover:bg-general-blue-secondary-darkmode",
        ],
        branded: [
            "hover:bg-general-indigo-secondary",
            "dark:hover:bg-general-indigo-secondary-darkmode",
        ],
    };
    const Icon = iconName ? IconComponents[`${iconName}Icon`] : null;
    const handleDelete = (e) => {
        e.preventDefault();
        !isDisabled && (onDelete === null || onDelete === void 0 ? void 0 : onDelete());
    };
    const handleKeyDown = (e) => {
        if (e.code === "Backspace") {
            e.preventDefault();
            !isDisabled && (onDelete === null || onDelete === void 0 ? void 0 : onDelete());
        }
    };
    return (_jsxs("div", { style: { overflowWrap: "anywhere" }, className: deletableTagClassName, onKeyDown: handleKeyDown, tabIndex: isDisabled ? undefined : 0, [theme.testAttribute]: testId, children: [Icon &&
                !avatar &&
                React.cloneElement(_jsx(Icon, { size: "xs" }), {
                    className: "min-w-2 mr-0.25 mt-[1px]",
                }), avatar && !Icon && (_jsx("span", { className: "flex min-w-2 mr-0.25  mt-[1px]", children: _jsx("img", { src: avatar, alt: "", width: 14, height: 14 }) })), _jsx(Typography, { variant: "body-small", color: "text-primary", children: text }), _jsx("span", { className: classNames("pr-1 cursor-pointer rounded-r-full", deletableAreaHoverClassName[color]), onClick: handleDelete, children: _jsx(IconComponents.CloseIcon, { className: "ml-0.5 mb-0.25", size: "xxs" }) })] }));
};
//# sourceMappingURL=DeletableTag.js.map